import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { CustomCoordinate } from '../../../../shared/models/customCoordinate';

@Component({
    selector: 'app-position-gadget',
    imports: [CommonModule, AngularSvgIconModule],
    templateUrl: './position-gadget.component.html',
    styleUrl: './position-gadget.component.scss'
})
export class PositionGadgetComponent {
  @Input() currentCoordinate: CustomCoordinate | undefined; // Replace `any` with the actual type if known
  @Input() isDegre: boolean = false;

  protected C1: string = 'X';
  protected C2: string = 'Y';



  ngOnChanges(): void {

    if (this.isDegre) {
      (this.C1 = 'G'), (this.C2 = 'L');
    } else {
      (this.C1 = 'X'), (this.C2 = 'Y');
    }
  }

}


